import { Component } from "react";

import { BTText } from "@btnet/core-components";
import { cn } from "@btnet/utilities-core";

import { track } from "utilities/analytics/analytics";

import { BTCol } from "commonComponents/btWrappers/BTCol/BTCol";
import { BTRow } from "commonComponents/btWrappers/BTRow/BTRow";

import "./EmptyState.less";

import { EmptyStateDataType, type IEmptyStateEntityProps } from "./common/EmptyState.api.types";

export interface IEmptyStateProps {
    title?: React.ReactNode;

    /**
     * Image that is displayed centered above the title & content
     */
    image?: React.ReactNode;

    style?: React.CSSProperties;
    className?: string;
    "data-testid"?: string;
    children?: React.ReactNode;
}

class EmptyStateBase extends Component<IEmptyStateProps> {
    render() {
        const { title, children, image, style, className, "data-testid": dataTestId } = this.props;

        return (
            <BTRow
                justify="center"
                align="middle"
                className={cn("EmptyState EmptyStateContainer", className)}
                style={style}
                data-testid={dataTestId}
            >
                <BTCol xs={20} sm={16} md={12} flex="auto" className="empty-state-content">
                    {image && (
                        <BTRow>
                            <BTCol>{image}</BTCol>
                        </BTRow>
                    )}
                    {title && (
                        <BTRow align="middle" className="padding-bottom-xss">
                            <BTCol>
                                <BTText text={title} size="distinct-lg" />
                            </BTCol>
                        </BTRow>
                    )}
                    <BTRow>
                        <BTCol xs={24} className="col-content">
                            <BTText text={children} size="normal-lg" />
                        </BTCol>
                    </BTRow>
                </BTCol>
            </BTRow>
        );
    }
}

export const EmptyState = track((props) => ({ component: "Empty State", uniqueId: props.title }))(
    EmptyStateBase,
);

export function getEmptyStateDataType(props: IEmptyStateEntityProps) {
    if (props.hasListData) {
        return null;
    }
    if (props.hasFilteredData) {
        return EmptyStateDataType.FilteredState;
    }
    if (props.hasTimeoutState!) {
        return EmptyStateDataType.TimeoutState;
    }
    return EmptyStateDataType.EmptyState;
}
